/** A technology as a chip: its mark in a tinted square, then its name. */
export default function TechChip({ tech }) {
  const { name, path, Icon, color } = tech;
  return (
    <span className="tech-chip">
      <span
        className="tech-icon"
        style={{ color, backgroundColor: `${color}14` }}
        aria-hidden="true"
      >
        {path ? (
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
            <path d={path} />
          </svg>
        ) : (
          <Icon size={22} strokeWidth={1.9} />
        )}
      </span>
      {name}
    </span>
  );
}
